import React, { useMemo, useState } from 'react';
import compact from 'lodash/compact';

import BulkUpdateInstructorsButton from '../BulkUpdateInstructorsButton';
import Field from 'components/Field';
import InstructorSelect from 'components/InstructorSelect';
import styles from './BulkUpdateInstructorsModalContent.module.scss';

function BulkUpdateInstructorsModalContent() {
  const [primaryInstructor, setPrimaryInstructor] = useState(null);
  const [secondaryInstructor, setSecondaryInstructor] = useState(null);
  const [otherInstructors, setOtherInstructors] = useState([]);

  const excludedInstructorIds = useMemo(() => {
    return compact(
      [primaryInstructor, secondaryInstructor, otherInstructors].flat()
    ).map((i) => i.value);
  }, [otherInstructors, primaryInstructor, secondaryInstructor]);

  return (
    <>
      <Field
        label="Instructor"
        labelClassName={styles.instructorHeading}
      >
        <div className={styles.instructorHeader}>
          <InstructorSelect
            value={primaryInstructor}
            placeholder="Primary Instructor"
            isClearable
            excludedInstructorIds={excludedInstructorIds}
            className="m-r-xs"
            onChange={setPrimaryInstructor}
          />
          <InstructorSelect
            value={secondaryInstructor}
            placeholder="Secondary Instructor"
            isClearable
            excludedInstructorIds={excludedInstructorIds}
            className="m-b-xs"
            onChange={setSecondaryInstructor}
          />
        </div>
        <div className={styles.otherInstructor}>
          <InstructorSelect
            value={otherInstructors}
            placeholder="Other Instructors"
            isMulti
            isClearable
            excludedInstructorIds={excludedInstructorIds}
            onChange={setOtherInstructors}
          />
        </div>
      </Field>
      <div className="warning m-l-xxs">
        If you don't select any Secondary Instructor then all the existing
        secondary Instructors will be removed.
      </div>
      <BulkUpdateInstructorsButton
        primaryInstructor={primaryInstructor}
        secondaryInstructor={secondaryInstructor}
        otherInstructors={otherInstructors}
      />
    </>
  );
}

export default BulkUpdateInstructorsModalContent;
